import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import {
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core';

import * as Yup from 'yup';

import moment from 'moment';

import * as S from './styles';

import { t } from '~/helpers';
import { TimeWeek, SelectDataInTable } from '~/components';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    width: 300,
    height: 130,
    overflow: 'auto',
  },
}));

export default function DadosHorarios({ data }) {
  const classes = useStyles();

  const cellsFeriado = React.useMemo(
    () => [
      { id: 'pdfe_nome_feriado', label: 'Nome' },
      { id: 'pdfe_data', label: 'Data' },
      { id: 'pdfe_atendimento_hora_ini', label: 'Func. Inicial' },
      { id: 'pdfe_atendimento_hora_fim', label: 'Func. Final' },
      { id: 'pdfe_almoco_hora_ini', label: 'Almoço Inicial' },
      { id: 'pdfe_almoco_hora_fim', label: 'Almoço Final' },
    ],
    []
  );

  function filtraSelecionados(data) {
    let encontrou = false;
    if (datasFeriado) {
      datasFeriado.map((dataFeriado) => {
        if (data.format('DD/MM/YYYY HH:mm:ss') === dataFeriado.pdfe_data) {
          encontrou = true;
        }
      });
    }
    return encontrou;
  }

  const camposFeriado = [
    {
      id: 'pdfe_nome_feriado',
      type: 'text',
      label: 'Nome Feriado',
    },
    {
      id: 'pdfe_data',
      type: 'datetime',
      label: 'Data',
      existentes: filtraSelecionados,
    },
    {
      id: 'pdfe_atendimento_status',
      type: 'radio',
      label: 'Status Atendimento',
      options: [
        {
          id: '1',
          label: 'Sim',
          value: '1',
        },
        {
          id: '0',
          label: 'Não',
          value: '0',
        },
      ],
    },
    {
      id: 'pdfe_atendimento_hora_ini',
      type: 'time',
      label: 'Hora Inicial Atendimento',
    },
    {
      id: 'pdfe_atendimento_hora_fim',
      type: 'time',
      label: 'Hora Final Atendimento',
    },
    {
      id: 'pdfe_almoco_status',
      type: 'radio',
      label: 'Status Almoço',
      options: [
        {
          id: '1',
          label: 'Sim',
          value: '1',
        },
        {
          id: '0',
          label: 'Não',
          value: '0',
        },
      ],
    },
    {
      id: 'pdfe_almoco_hora_ini',
      type: 'time',
      label: 'Hora Inicial Almoço',
    },
    {
      id: 'pdfe_almoco_hora_fim',
      type: 'time',
      label: 'Hora Final Almoço',
    },
  ];

  // dias e horarios

  const [diasAtendimento, setDiasAtendimento] = useState(data.diasAtendimento);
  const [diasAlmoco, setDiasAlmoco] = useState(data.diasAlmoco);

  // feriados

  const [datasFeriado, setDatasFeriado] = useState(data.datasFeriado);

  // atualiza dias atendimento

  function handleAtualizaDiasAtendimento(diasEdicao) {
    let bd = [];
    let erro = false;
    diasEdicao.map((value) => {
      if (value.error) {
        erro = true;
      }
      bd.push({
        poco_codigo: data.posto.poco_codigo,
        pdat_dia: value.day,
        pdat_hora_ini: moment(value.initial, 'HH:mm').format(
          'DD/MM/YYYY HH:mm:ss'
        ),
        pdat_hora_fim: moment(value.final, 'HH:mm').format(
          'DD/MM/YYYY HH:mm:ss'
        ),
      });
    });
    data.diasAtendimento = bd;
    data.erroDiasAtendimento = erro;
  }

  // atualiza dias almoco

  function handleAtualizaDiasAlmoco(diasEdicao) {
    let bd = [];
    let erro = false;
    diasEdicao.map((value) => {
      if (value.error) {
        erro = true;
      }
      bd.push({
        poco_codigo: data.posto.poco_codigo,
        pdal_dia: value.day,
        pdal_hora_ini: moment(value.initial, 'HH:mm').format(
          'DD/MM/YYYY HH:mm:ss'
        ),
        pdal_hora_fim: moment(value.final, 'HH:mm').format(
          'DD/MM/YYYY HH:mm:ss'
        ),
      });
    });
    data.diasAlmoco = bd;
    data.erroDiasAlmoco = erro;
  }

  // atualiza com a edicao

  function handleAtualizaFeriados(muns) {
    let mns = [];
    let erro = false;
    if (muns) {
      muns.map((value) => {
        // verifica se id ja existente, se sim configura erro
        mns.forEach((m) => {
          if (m.pdfe_data === value.pdfe_data + ' 00:00:00') {
            erro = true;
          }
        });
        // acrescenta item (mesmo com erro)
        mns.push({
          poco_codigo: data.posto.poco_codigo,
          pdfe_data: moment(value.pdfe_data, 'DD/MM/YYYY').format(
            'DD/MM/YYYY HH:mm:ss'
          ),
          pdfe_nome_feriado: value.pdfe_nome_feriado,
          pdfe_atendimento_status: value.pdfe_atendimento_status,
          pdfe_atendimento_hora_ini:
            value.pdfe_atendimento_status === '1'
              ? moment(value.pdfe_atendimento_hora_ini, 'HH:mm').format(
                  'DD/MM/YYYY HH:mm:ss'
                )
              : null,
          pdfe_atendimento_hora_fim:
            value.pdfe_atendimento_status === '1'
              ? moment(value.pdfe_atendimento_hora_fim, 'HH:mm').format(
                  'DD/MM/YYYY HH:mm:ss'
                )
              : null,
          pdfe_almoco_status: value.pdfe_almoco_status,
          pdfe_almoco_hora_ini:
            value.pdfe_almoco_status === '1'
              ? moment(value.pdfe_almoco_hora_ini, 'HH:mm').format(
                  'DD/MM/YYYY HH:mm:ss'
                )
              : null,
          pdfe_almoco_hora_fim:
            value.pdfe_almoco_status === '1'
              ? moment(value.pdfe_almoco_hora_fim, 'HH:mm').format(
                  'DD/MM/YYYY HH:mm:ss'
                )
              : null,
        });
      });
    }
    data.datasFeriado = mns;
    data.erroFeriados = erro;
  }

  function handleEdicaoCampos(value) {
    // configura campos apos a edicao - verifica se inclusao ou alteracao
    let poco_codigo = data.posto.poco_codigo;
    return {
      ...value,
      id: value.pdfe_data,
      label: value.pdfe_nome_feriado,
      value: value.pdfe_data,
      poco_codigo: poco_codigo,
      pdfe_atendimento_status: value.pdfe_atendimento_status,
      pdfe_atendimento_hora_ini: value.pdfe_atendimento_hora_ini,
      pdfe_atendimento_hora_fim: value.pdfe_atendimento_hora_fim,
      pdfe_almoco_status: value.pdfe_almoco_status,
      pdfe_almoco_hora_ini: value.pdfe_almoco_hora_ini,
      pdfe_almoco_hora_fim: value.pdfe_almoco_hora_fim,
    };
  }

  return (
    <>
      <S.ConteinerTab>
        <ExpansionPanelSummary
          aria-controls="panel4a-content"
          id="panel4a-header"
          style={{
            background: 'rgba(0, 0, 0, 0.05)',
            borderBottom: '1px solid rgba(0,0,0,.2)',
          }}
        >
          <Typography>Atendimento</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <TimeWeek
            data={diasAtendimento.map((value) => ({
              day: Number(value.pdat_dia),
              initial: moment(
                value.pdat_hora_ini,
                'DD/MM/YYYY HH:mm:ss'
              ).format('HH:mm'),
              final: moment(value.pdat_hora_fim, 'DD/MM/YYYY HH:mm:ss').format(
                'HH:mm'
              ),
            }))}
            onChangeDays={(value) => handleAtualizaDiasAtendimento(value)}
            desktop={4}
          />
        </ExpansionPanelDetails>
        <ExpansionPanelSummary
          aria-controls="panel4a-content"
          id="panel4a-header"
          style={{
            background: 'rgba(0, 0, 0, 0.05)',
            borderBottom: '1px solid rgba(0,0,0,.2)',
          }}
        >
          <Typography>Almoço</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <TimeWeek
            data={diasAlmoco.map((value) => ({
              day: Number(value.pdal_dia),
              initial: moment(
                value.pdal_hora_ini,
                'DD/MM/YYYY HH:mm:ss'
              ).format('HH:mm'),
              final: moment(value.pdal_hora_fim, 'DD/MM/YYYY HH:mm:ss').format(
                'HH:mm'
              ),
            }))}
            onChangeDays={(value) => handleAtualizaDiasAlmoco(value)}
            desktop={4}
          />
        </ExpansionPanelDetails>
        <ExpansionPanelSummary
          aria-controls="panel4a-content"
          id="panel4a-header"
          style={{
            background: 'rgba(0, 0, 0, 0.05)',
            borderBottom: '1px solid rgba(0,0,0,.2)',
          }}
        >
          <Typography>Feriados</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div style={{ width: '100%' }}>
            <SelectDataInTable
              // noEdition
              cells={cellsFeriado}
              items={[]}
              fields={camposFeriado}
              initials={datasFeriado.map((value) => ({
                poco_codigo: value.poco_codigo,
                pdfe_data: moment(
                  value.pdfe_data,
                  'DD/MM/YYYY HH:mm:ss'
                ).format('DD/MM/YYYY'),
                pdfe_nome_feriado: value.pdfe_nome_feriado,
                pdfe_atendimento_status: value.pdfe_atendimento_status,
                pdfe_atendimento_hora_ini:
                  value.pdfe_atendimento_status === '1'
                    ? moment(
                        value.pdfe_atendimento_hora_ini,
                        'DD/MM/YYYY HH:mm:ss'
                      ).format('HH:mm')
                    : null,
                pdfe_atendimento_hora_fim:
                  value.pdfe_atendimento_status === '1'
                    ? moment(
                        value.pdfe_atendimento_hora_fim,
                        'DD/MM/YYYY HH:mm:ss'
                      ).format('HH:mm')
                    : null,
                pdfe_almoco_status: value.pdfe_almoco_status,
                pdfe_almoco_hora_ini:
                  value.pdfe_almoco_status === '1'
                    ? moment(
                        value.pdfe_almoco_hora_ini,
                        'DD/MM/YYYY HH:mm:ss'
                      ).format('HH:mm')
                    : null,
                pdfe_almoco_hora_fim:
                  value.pdfe_almoco_status === '1'
                    ? moment(
                        value.pdfe_almoco_hora_fim,
                        'DD/MM/YYYY HH:mm:ss'
                      ).format('HH:mm')
                    : null,
                pdfe_atendimento_status: value.pdfe_atendimento_status,
                pdfe_almoco_status: value.pdfe_almoco_status,
              }))}
              label="Feriados"
              onChanged={(values) => handleAtualizaFeriados(values)}
              unique="pdfe_data"
              // onField={(value) => handleEdicaoCampos(value)}
              schema={{
                pdfe_nome_feriado: Yup.string().required(
                  t('s.geral.validacao.campoobrigatorio')
                ),
                pdfe_data: Yup.string().required(
                  t('s.geral.validacao.campoobrigatorio')
                ),
                pdfe_atendimento_status: Yup.string().required(
                  t('s.geral.validacao.campoobrigatorio')
                ),
                pdfe_atendimento_hora_ini: Yup.string().when(
                  'pdfe_atendimento_status',
                  {
                    is: (value) => value === '1',
                    then: Yup.string().required(
                      t('s.geral.validacao.campoobrigatorio')
                    ),
                    // .matches(
                    //   /(?:[01]\d|2[0123]):(?:[012345]\d)/,
                    //   'Coloque a hora correta HH:MM'
                    // ),
                    otherwise: Yup.string().nullable(),
                  }
                ),
                pdfe_atendimento_hora_fim: Yup.string().when(
                  'pdfe_atendimento_status',
                  {
                    is: (value) => value === '1',
                    then: Yup.string().required(
                      t('s.geral.validacao.campoobrigatorio')
                    ),
                    otherwise: Yup.string().nullable(),
                  }
                ),
                pdfe_almoco_status: Yup.string().required(
                  t('s.geral.validacao.campoobrigatorio')
                ),
                pdfe_almoco_hora_ini: Yup.string().when('pdfe_almoco_status', {
                  is: (value) => value === '1',
                  then: Yup.string().required(
                    t('s.geral.validacao.campoobrigatorio')
                  ),
                  otherwise: Yup.string().nullable(),
                }),
                pdfe_almoco_hora_fim: Yup.string().when('pdfe_almoco_status', {
                  is: (value) => value === '1',
                  then: Yup.string().required(
                    t('s.geral.validacao.campoobrigatorio')
                  ),
                  otherwise: Yup.string().nullable(),
                }),
              }}
              isIgnore="pdfe_data"
            />
          </div>
        </ExpansionPanelDetails>
      </S.ConteinerTab>
    </>
  );
}
